import {Stack, Typography} from '@mui/material';
import React, {Fragment} from 'react';

import {AlertInfo, Modal} from 'presentation/components';
import {useAccountInformation, useMediaQueries} from 'presentation/pages';
import {translations} from 'presentation/translations-new';
import {SectionContainer} from '../../../SectionContainer';
import {GracePeriodCard} from '../GracePeriodCard';
import {StyledStack, StyledSubheader} from './styles';
import {GracePeriodDetailsProps} from './types';

const {healthPeriods, odontoPeriods, planGracePeriodInfo} = translations['pt-br'].privateFlow.home;

export function GracePeriodDetails({setShowDetails, showDetails}: GracePeriodDetailsProps) {
	const {isLaptop} = useMediaQueries();
	const {healthOnly, odontoOnly} = useAccountInformation();

	return (
		<Fragment>
			{isLaptop ? (
				<Modal.Root open={showDetails} onClose={() => setShowDetails(false)}>
					<Modal.Header
						onClose={() => setShowDetails(false)}
						title="Períodos de carência"
					/>
					<StyledSubheader>
						<Typography variant="h6" color="white">
							Fique atento ao período de carência do seu plano
						</Typography>
					</StyledSubheader>
					<StyledStack>
						<AlertInfo.Root color="info">
							<AlertInfo.Description>{planGracePeriodInfo}</AlertInfo.Description>
						</AlertInfo.Root>
						{!odontoOnly ? (
							<SectionContainer showTitle title={healthPeriods} titleMarginTop={0}>
								<GracePeriodCard planType="health" />
							</SectionContainer>
						) : null}
						{!healthOnly ? (
							<SectionContainer showTitle title={odontoPeriods} titleMarginTop={0}>
								<GracePeriodCard planType="odonto" />
							</SectionContainer>
						) : null}
					</StyledStack>
				</Modal.Root>
			) : (
				<Fragment>
					<Stack gap={2}>
						<AlertInfo.Root color="info" sx={{mt: 2}}>
							<AlertInfo.Description>{planGracePeriodInfo}</AlertInfo.Description>
						</AlertInfo.Root>
						{!odontoOnly ? (
							<SectionContainer showTitle title={healthPeriods} titleMarginTop={0}>
								<GracePeriodCard planType="health" />
							</SectionContainer>
						) : null}
						{!healthOnly ? (
							<SectionContainer showTitle title={odontoPeriods} titleMarginTop={0}>
								<GracePeriodCard planType="odonto" />
							</SectionContainer>
						) : null}
					</Stack>
				</Fragment>
			)}
		</Fragment>
	);
}
